import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { AgGrid } from '../../AgGrid';
import classnames from 'classnames';

// SERVICES
import { getAdminUsers } from '../../../services';

const styles = theme => ({});

export const AdminUsersGrid = withStyles(styles)(props => {
  const [gridData, setGridData] = useState(null);

  const columnDefinitions = [
    { headerName: 'Username', field: 'userName', width: 300 },
    { headerName: 'E-mail', field: 'email', width: 300 },
  ];

  const gridOptions = {};

  const getAdminUsersAsync = async () => {
    try {
      const data = await getAdminUsers();
      setGridData(data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getAdminUsersAsync();
  }, []);

  return (
    <div className={classnames('flex-1', 'col-center-center')}>
      <AgGrid
        gridData={gridData}
        gridOptions={gridOptions}
        columnDefs={columnDefinitions}
        showCreateButton={true}
        redirectOnClick={true}
        editOnClick={false}
      />
    </div>
  );
});
